var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { staticClass: "wrap-cart mt-5", attrs: { wrap: "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "fixed-bottom-right",
          attrs: { color: "primary", disabled: _vm.cartTotal == 0 },
          on: {
            click: function ($event) {
              _vm.orderNoteDialog = true
            },
          },
        },
        [
          _vm._v(" SEND ORDER "),
          _c("v-icon", { staticStyle: { "margin-left": "8px" } }, [
            _vm._v("send"),
          ]),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", absolute: "", color: "primary" },
          model: {
            value: _vm.cartUpdated,
            callback: function ($$v) {
              _vm.cartUpdated = $$v
            },
            expression: "cartUpdated",
          },
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.cartUpdatedNotify))]),
          _c(
            "v-btn",
            {
              staticStyle: { top: "5px", right: "5px" },
              attrs: { text: "", absolute: "" },
              on: {
                click: function ($event) {
                  _vm.cartUpdated = false
                },
              },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-md": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px", transition: "dialog-transition" },
              model: {
                value: _vm.orderNoteDialog,
                callback: function ($$v) {
                  _vm.orderNoteDialog = $$v
                },
                expression: "orderNoteDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "login-window", attrs: { shaped: "" } },
                [
                  _c(
                    "v-toolbar",
                    { staticClass: "primary", attrs: { dark: "" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("message.Note"))),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.orderNoteDialog = false
                                  _vm.note = ""
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticStyle: { "margin-top": "1rem" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          filled: "",
                          clearable: "",
                          "hide-details": "",
                          placeholder: "Inserisci le note per il tuo custom",
                          name: "row-notes",
                        },
                        model: {
                          value: _vm.orderNote,
                          callback: function ($$v) {
                            _vm.orderNote = $$v
                          },
                          expression: "orderNote",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "justify-end": "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "red" },
                              on: {
                                click: function ($event) {
                                  _vm.orderNoteDialog = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("message.Annulla")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.showConfirmOrder = true
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("message.Conferma")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px", transition: "dialog-transition" },
              model: {
                value: _vm.showConfirmOrder,
                callback: function ($$v) {
                  _vm.showConfirmOrder = $$v
                },
                expression: "showConfirmOrder",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "login-window", attrs: { shaped: "" } },
                [
                  _c(
                    "v-toolbar",
                    { staticClass: "primary", attrs: { dark: "" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("message.Conferma_d*ordine"))),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.showConfirmOrder = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", { staticStyle: { "margin-top": "1rem" } }, [
                    _c("p", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("upperCase")(_vm.$t("message.Ricorda_che"))
                        ) + ":"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message.A_partire_da_ora_il_tuo_ordine_sarà_inviato_in_produzione_e,_salvo_casi_eccezionali,_non_potrà_essere_modificato**"
                          )
                        )
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message.Puoi_contattarci_per_richiedere_le_modifiche,_che,_se_possibili,_saranno_eseguite_e_potrebbero_comportare_un_ritardo_nella_consegna_e_dei_costi_aggiuntivi**"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "justify-end": "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "red" },
                              on: {
                                click: function ($event) {
                                  _vm.showConfirmOrder = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("message.Annulla")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.showConfirmOrder = false
                                  _vm.checkout()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("message.Invia_ordine")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-layout",
            {
              staticClass: "items-cart-wrapper",
              attrs: {
                wrap: "",
                "justify-space-around": "",
                "align-center": "",
              },
            },
            [
              _c(
                "v-flex",
                {
                  staticClass: "d-flex",
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: {
                    row: "",
                    wrap: "",
                    "align-center": "",
                    "justify-center": "",
                    shrink: "",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        xs12: "",
                        disabled: _vm.cartTotal == 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.emptyCart()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("message.Svuota")) +
                          " " +
                          _vm._s(_vm.$t("message.Carrello")) +
                          " "
                      ),
                      _c("v-icon", { staticStyle: { "margin-left": "8px" } }, [
                        _vm._v("remove_shopping_cart"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.showPrice
            ? _c("v-flex", { staticStyle: { "text-align": "center" } }, [
                _c("h2", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.Totale_carrello")) +
                      ": " +
                      _vm._s(_vm.totalPrice) +
                      _vm._s(_vm._f("currency")(_vm.user.currency))
                  ),
                ]),
              ])
            : _vm._e(),
          _c(
            "v-scale-transition",
            {
              staticClass: "layout row wrap justify-center",
              attrs: { group: "", "leave-absolute": "", tag: "div" },
            },
            [
              _vm._l(_vm.items, function (row) {
                return [
                  _c("item-card", {
                    key: row.id,
                    attrs: {
                      item: row,
                      canDelete: true,
                      showPrice: _vm.showPrice,
                      frontColorWarning: _vm.warnings[row.colore],
                    },
                    on: { delete: _vm.deleteCartRow },
                  }),
                ]
              }),
            ],
            2
          ),
          _c("div", { staticClass: "spacer-100" }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.checkoutStatusDialog,
            callback: function ($$v) {
              _vm.checkoutStatusDialog = $$v
            },
            expression: "checkoutStatusDialog",
          },
        },
        [
          _vm.checkingOut
            ? _c(
                "v-card",
                { staticClass: "login-window" },
                [
                  _c(
                    "v-card-text",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("message.Processando_l*ordine")) +
                          "... "
                      ),
                      _c("v-progress-linear", {
                        attrs: { color: "primary", indeterminate: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-layout",
                [
                  _vm.checkoutSuccess
                    ? _c(
                        "v-card",
                        { staticClass: "login-window" },
                        [
                          _c(
                            "v-toolbar",
                            { staticClass: "primary", attrs: { dark: "" } },
                            [
                              _c("v-toolbar-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.Ordine_completato_con_successo"
                                    )
                                  )
                                ),
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-toolbar-items",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", dark: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.checkoutStatusDialog = false
                                          _vm.$emit("closeCartDialog")
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "message.Il_suo_ordine_è_stato_inviato_con_successo_e_a_breve_verrà_processato"
                                  )
                                ) +
                                "."
                            ),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("message.Grazie_per_averci_scelto")
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _c(
                        "v-card",
                        [
                          _c(
                            "v-toolbar",
                            { staticClass: "primary", attrs: { dark: "" } },
                            [
                              _c("v-toolbar-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.Si_è_verificato_un_problema"
                                    )
                                  )
                                ),
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-toolbar-items",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", dark: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("closeCartDialog")
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "message.Non_è_stato_possibile_processare_l'ordine,_riprova_più_tardi"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }